import { Paper, Stack, Box, Typography, Chip, Divider } from '@mui/material'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import StorefrontIcon from '@mui/icons-material/Storefront'
import PersonIcon from '@mui/icons-material/Person'
import EventIcon from '@mui/icons-material/Event'

const BagSummaryCard = ({ bag }) => {
  // Mobile stores (allowAdministration) come through the same form - no
  // level, no seal tag.
  const isStore = bag?.type === 'Medicine Store'
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 3,
        bgcolor: 'background.paper',
        borderColor: 'secondary.main',
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        alignItems={{ xs: 'flex-start', md: 'center' }}
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="overline" color="secondary.main">
            {isStore ? 'Selected Mobile Store' : 'Selected Medicine Bag'}
          </Typography>

          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            flexWrap="wrap"
          >
            <Typography variant="h6" fontWeight={800}>
              {bag?.name ?? `Bag ${bag?.number ?? ''}`}
            </Typography>

            {bag?.level && (
              <Chip
                size="small"
                label={bag.level}
                color="primary"
                variant="outlined"
              />
            )}
          </Stack>
        </Box>

        <Stack direction="row" spacing={1} flexWrap="wrap">
          {!isStore && (
            <Chip
              icon={<LocalOfferIcon />}
              label={`Tag: ${bag?.tagNumber || 'Unknown'}`}
              variant="outlined"
              color="anBlue"
            />
          )}

          {bag?.assignedToStore && (
            <Chip
              icon={<StorefrontIcon />}
              label={bag.assignedToStore.name}
              color="anBlue"
              variant="outlined"
            />
          )}

          {bag?.assignedToVehicle && (
            <Chip
              icon={<DirectionsCarIcon />}
              label={bag.assignedToVehicle.callSign}
              color="anBlue"
              variant="outlined"
            />
          )}

          {bag?.assignedToEvent && (
            <Chip
              icon={<EventIcon />}
              label={bag.assignedToEvent.title}
              color="anBlue"
              variant="outlined"
            />
          )}

          {bag?.assignedToEmployee && (
            <Chip
              icon={<PersonIcon />}
              label={`${bag.assignedToEmployee.userAccount.firstName} ${bag.assignedToEmployee.userAccount.lastName}`}
              color="anBlue"
              variant="outlined"
            />
          )}
        </Stack>
      </Stack>
    </Paper>
  )
}

export default BagSummaryCard
